import { handleAxiosErrors } from '../../_utils';
import { convertPICNumberListingToAReadableFormat } from '../../selectors/converterSelector';
import { toggleLoading, setUserInfo } from '../userActions';
import {
    axiosCreatePICNumber,
    axiosDeletePICNumber,
    axiosRequestPICNumbers,
    axioxMakeDefaultPICNumber,
} from '../picNumberActions';

/**
 * Request PIC numbers
 */
export const requestPICNumbers = () => {
    return (dispatch) => {
        dispatch(toggleLoading('picNumberList', true));
        return axiosRequestPICNumbers()
            .then((response) => {
                const picNumbers = convertPICNumberListingToAReadableFormat(
                    response.data.data.readPICNumbers
                );
                dispatch(
                    setUserInfo({
                        availablePICNumbers: Object.values(picNumbers),
                    })
                );

                dispatch(toggleLoading('picNumberList', false));
            })
            .catch((error) => {
                handleAxiosErrors(error);
                dispatch(toggleLoading('picNumberList', false));
            });
    };
};

export const createPICNumber = (formData, callback) => {
    return (dispatch) => {
        const successCallback = typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback = typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback = typeof callback.always != 'undefined' ? callback.always : null;

        return axiosCreatePICNumber(formData)
            .then((response) => {
                dispatch(requestPICNumbers());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

/**
 * Set default PIC number
 *
 * @param picNumberID
 * @param callback
 */
export const makeDefaultPICNumber = (picNumberID, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axioxMakeDefaultPICNumber(picNumberID)
            .then((response) => {
                dispatch(requestPICNumbers());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

/**
 * Delete the selected PIC number
 *
 * @param picNumberID
 * @param callback
 */
export const deletePICNumber = (picNumberID, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosDeletePICNumber(picNumberID)
            .then((response) => {
                dispatch(requestPICNumbers());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};
